import React from 'react';
import { Form, Input, Select, InputNumber, Button, Row, Col } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Option } = Select;
const { TextArea } = Input;

const FamilyHistorySection = () => {
  const { t } = useTranslation();

  const relationOptions = [
    { value: 'Mother', label: t('intake.medicalHistory.familyHistory.relations.mother') },
    { value: 'Father', label: t('intake.medicalHistory.familyHistory.relations.father') },
    { value: 'Sister', label: t('intake.medicalHistory.familyHistory.relations.sister') },
    { value: 'Brother', label: t('intake.medicalHistory.familyHistory.relations.brother') },
    { value: 'Maternal Grandmother', label: t('intake.medicalHistory.familyHistory.relations.maternalGrandmother') },
    { value: 'Maternal Grandfather', label: t('intake.medicalHistory.familyHistory.relations.maternalGrandfather') },
    { value: 'Paternal Grandmother', label: t('intake.medicalHistory.familyHistory.relations.paternalGrandmother') },
    { value: 'Paternal Grandfather', label: t('intake.medicalHistory.familyHistory.relations.paternalGrandfather') },
    { value: 'Aunt', label: t('intake.medicalHistory.familyHistory.relations.aunt') },
    { value: 'Uncle', label: t('intake.medicalHistory.familyHistory.relations.uncle') },
    { value: 'Cousin', label: t('intake.medicalHistory.familyHistory.relations.cousin') },
    { value: 'Other', label: t('intake.medicalHistory.familyHistory.relations.other') }
  ];

  return (
    <Form.List name="familyHistory">
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name, ...restField }) => (
            <div key={key} className="medical-history-item">
              <Row gutter={[16, 0]}>
                <Col xs={24} sm={8}>
                  <Form.Item
                    {...restField}
                    name={[name, 'relation']}
                    label={t('intake.medicalHistory.familyHistory.fields.relation')}
                    rules={[
                      { required: true, message: t('intake.medicalHistory.familyHistory.validation.relationRequired') }
                    ]}
                  >
                    <Select placeholder={t('intake.medicalHistory.familyHistory.placeholders.selectRelation')}>
                      {relationOptions.map(relation => (
                        <Option key={relation.value} value={relation.value}>{relation.label}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={10}>
                  <Form.Item
                    {...restField}
                    name={[name, 'condition']}
                    label={t('intake.medicalHistory.familyHistory.fields.condition')}
                    rules={[
                      { required: true, message: t('intake.medicalHistory.familyHistory.validation.conditionRequired') },
                      { max: 200, message: t('intake.medicalHistory.familyHistory.validation.conditionMaxLength') }
                    ]}
                  >
                    <Input placeholder={t('intake.medicalHistory.familyHistory.placeholders.condition')} />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={6}>
                  <Form.Item
                    {...restField}
                    name={[name, 'ageAtDiagnosis']}
                    label={t('intake.medicalHistory.familyHistory.fields.ageAtDiagnosis')}
                  >
                    <InputNumber
                      style={{ width: '100%' }}
                      placeholder={t('intake.medicalHistory.familyHistory.placeholders.age')}
                      min={0}
                      max={120}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[16, 0]}>
                <Col xs={24}>
                  <Form.Item
                    {...restField}
                    name={[name, 'notes']}
                    label={t('intake.medicalHistory.familyHistory.fields.notes')}
                  >
                    <TextArea
                      rows={2}
                      placeholder={t('intake.medicalHistory.familyHistory.placeholders.notes')}
                      maxLength={300}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div className="remove-item-button">
                <Button
                  type="text"
                  danger
                  icon={<MinusCircleOutlined />}
                  onClick={() => remove(name)}
                >
                  {t('intake.medicalHistory.familyHistory.buttons.remove')}
                </Button>
              </div>
            </div>
          ))}

          <Form.Item>
            <Button
              type="dashed"
              onClick={() => add()}
              block
              icon={<PlusOutlined />}
            >
              {t('intake.medicalHistory.familyHistory.buttons.add')}
            </Button>
          </Form.Item>

          {fields.length === 0 && (
            <div className="no-items-message">
              <p>{t('intake.placeholders.noFamilyHistory')}</p>
            </div>
          )}
        </>
      )}
    </Form.List>
  );
};

export default FamilyHistorySection;
